import { render, staticRenderFns } from "./auditlog-view.vue?vue&type=template&id=31590cc6&"
import script from "./auditlog-view.vue?vue&type=script&lang=ts&"
export * from "./auditlog-view.vue?vue&type=script&lang=ts&"
import style0 from "./auditlog-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAlert,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
